import './App.css';
import { Route, Routes } from 'react-router-dom';
import Home from './pages/home';
import Event from 'pages/event';
import Inplay from 'pages/inPlay';
import IPL from 'pages/ipl';
import ICC2025 from 'pages/icc2025';
import Game from 'pages/game';
import LudoCricket from 'pages/ludoCricket';
import RoyalCasino from 'pages/royalCasino';
import IndianPoker from 'pages/indianPoker';
import Aviator from 'pages/aviator';
import AESexyBCRT from 'pages/aeSexyBCRT';
import Evolution from 'pages/evolution';
import LiveCasino from 'pages/liveCasino';
import Vivo from 'pages/vivo';
import BetGames from 'pages/betGames';
import Casino3 from 'pages/casino3';
import AccountStatement from 'pages/accountStatement';
import ProfitLoss from 'pages/profitLoss';
import BetHistroy from 'pages/bethistroy';
import UnsettledBet from 'pages/unsettledBet';
import SetStake from 'pages/setStake';
import Rules from 'pages/rules';
import ChangePassword from 'pages/changePassword';
import Result from 'pages/result';
import Dashboard from 'pages/dashboard';
import Login from 'pages/login';
import ProtectedRoute from 'components/ProtectedRoute';
import UserList from 'pages/downline-list/user';
import UserBanking from 'pages/banking/user-banking';
import AdminFund from 'pages/mySettings/adminFund';
import News from 'pages/mySettings/news';
import Banner from 'pages/mySettings/addBanner';
import { socket, WebSocketContext } from 'context/websocket';
import PasswordHistory from 'pages/password-history';
import RestoreUser from 'pages/restore-users';
import EventType from 'pages/block-markets/event-type';
import MarketTypes from 'pages/block-markets/market-types';
import BlockedEvents from 'pages/block-markets/events';
import BlockedMarketTypes from 'pages/block-markets/market-types';
import UserGeneralSetting from 'pages/user-general-setting';
import EventGeneralSetting from 'pages/event-general-setting/event-setting-eventtypes';
import EventSettingMarketEvents from 'pages/event-general-setting/event-setting-event-names';
import EventSettingUpdate from 'pages/event-general-setting/event-setting-update';
import MasterList from 'pages/downline-list/master';
import MyAccount from 'pages/myAccount';
import MarketAnalysis from 'pages/market-analysis';
import ChipSummary from 'pages/chipSummary';
import ClientPL from 'pages/clientPL';
import MarketPL from 'pages/marketPL';
import SportPL from 'pages/sportPL';
import MatchPL from 'pages/matchPL';
import MatchDetailList from 'pages/matchDetailList';
import UserShowBets from 'pages/userShowBets';
import FancySale from 'pages/fancySale';
import MatchSale from 'pages/matchSale';
import AuthCheck from 'components/AuthCheck/AuthCheck';
import Betting from 'pages/mySettings/betting';
import EventOpenBetting from 'pages/mySettings/event-open-betting';
import EventOpenBettingData from 'pages/mySettings/event-open-betting-data';

import { WebSocketProvider } from "./context/WebSocketProvider";


function App() {

  return (
    // <WebSocketContext.Provider value={socket}>
    <WebSocketProvider url="wss://ws.operator.buzz:7072">
      <AuthCheck />
      <Routes>
        <Route index element={<Home />} />
        <Route path='/home' element={<Home />} />
        <Route path='/login' element={<Login />} />
        <Route path='/event/:event_type_id/:event_id' element={<Event />} />
        <Route path='/inplay' element={<Inplay />} />
        <Route path='/ipl' element={<IPL />} />
        {/* <Route path='/icc2025' element={<ICC2025 />} /> */}
        <Route path='/game/:id' element={<Game />} />
        <Route path='/ludocricket' element={<LudoCricket />} />
        <Route path='/royalcasino' element={<RoyalCasino />} />
        <Route path='/indianpoker' element={<IndianPoker />} />
        <Route path='/spribe' element={<Aviator />} />
        <Route path='/aesexybcrt' element={<AESexyBCRT />} />
        <Route path='/evolution' element={<Evolution />} />
        <Route path='/livecasino' element={<IndianPoker />} />
        <Route path='/vivo' element={<Vivo />} />
        <Route path='/betgames' element={<BetGames />} />
        <Route path='/casino3' element={<AESexyBCRT />} />
        <Route path='/accountstatement' element={<AccountStatement />} />
        <Route path='/matchDetailList/:match_id/:selection_id' element={<MatchDetailList />} />
        <Route path='/usershowBets/:match_id/:market_id/:is_fancy' element={<UserShowBets />} />
        <Route path='/profitloss' element={<ProfitLoss />} />
        <Route path='/bethistroy' element={<BetHistroy />} />
        <Route path='/unsettledbet' element={<UnsettledBet />} />
        <Route path='/userprofile' element={<SetStake />} />
        <Route path='/rules' element={<Rules />} />
        <Route path='/changepassword' element={<ChangePassword />} />
        <Route path='/result' element={<Result />} />



        {/* admin routes */}
        <Route
          path="/dashboard"
          element={<ProtectedRoute
            element={<Dashboard />}
            requiredRoles={['Managment', 'Administrative', 'Tech Admin', 'Super Admin', 'Admin', 'Hyper', 'Super', 'Master']}
          />}
        />
        {/* <Route
          path="/list/:user_id/:user_type"
          element={<ProtectedRoute
            element={<UserList />}
            requiredRoles={['Super Admin', 'Administrative', 'Admin', 'Sub Admin', 'Hyper', 'Super Master', 'Super', 'Master', 'Agent']}
          />}
        /> */}
        <Route
          path="/list/user"
          element={<ProtectedRoute
            element={<UserList />}
            // requiredRoles={['Super Admin', 'Administrative', 'Admin', 'Sub Admin', 'Hyper', 'Super Master', 'Super', 'Master', 'Agent']}
            requiredRoles={['Managment', 'Administrative', 'Tech Admin', 'Super Admin', 'Admin', 'Hyper', 'Super', 'Master']}
          />}
        />
        <Route
          path="/list/:user_id/:user_type"
          element={<ProtectedRoute
            element={<UserList />}
            requiredRoles={['Managment', 'Administrative', 'Tech Admin', 'Super Admin', 'Admin', 'Hyper', 'Super', 'Master']}
          />}
        />
        <Route
          path="/list/master"
          element={<ProtectedRoute
            element={<MasterList />}
            requiredRoles={['Managment', 'Administrative', 'Tech Admin', 'Super Admin', 'Admin', 'Hyper', 'Super', 'Master']}
          />}
        />

        <Route
          path='/market-analysis'
          element={<ProtectedRoute
            element={<MarketAnalysis />}
            requiredRoles={['Managment', 'Administrative', 'Tech Admin', 'Super Admin', 'Admin', 'Hyper', 'Super', 'Master', 'User']}
          />}
        />

        <Route
          path="/my-account"
          element={<ProtectedRoute
            element={<MyAccount />}
            // requiredRoles={['Super Admin', 'Administrative', 'Admin', 'Sub Admin', 'Hyper', 'Super Master', 'Super', 'Master', 'Agent']}
            requiredRoles={['Managment', 'Administrative', 'Tech Admin', 'Super Admin', 'Admin', 'Hyper', 'Super', 'Master']}
          />}
        />

        <Route
          path="/user-banking"
          element={<ProtectedRoute
            element={<UserBanking />}
            // requiredRoles={['Super Admin', 'Administrative', 'Admin', 'Sub Admin', 'Hyper', 'Super Master', 'Super', 'Master', 'Agent']}
            requiredRoles={['Managment', 'Administrative', 'Tech Admin', 'Super Admin', 'Admin', 'Hyper', 'Super', 'Master']}
          />}
        />
        <Route
          path="/adminfund"
          element={<ProtectedRoute
            element={<AdminFund />}
            // requiredRoles={['Managment', 'Administrative']}
            requiredRoles={['Managment', 'Administrative', 'Tech Admin', 'Super Admin', 'Admin', 'Hyper', 'Super', 'Master']}
          />}
        />
        <Route
          path="/betting"
          element={<ProtectedRoute
            element={<Betting />}
            // requiredRoles={['Managment', 'Administrative']}
            requiredRoles={['Managment', 'Administrative', 'Tech Admin', 'Super Admin', 'Admin', 'Hyper', 'Super', 'Master']}
          />}
        />
        <Route
          path="/betting/eventOpenBetting/:event_type"
          element={<ProtectedRoute
            element={<EventOpenBetting />}
            // requiredRoles={['Managment', 'Administrative']}
            requiredRoles={['Managment', 'Administrative', 'Tech Admin', 'Super Admin', 'Admin', 'Hyper', 'Super', 'Master']}
          />}
        />
        <Route
          path="/betting/openBetsByEvent/:event_id"
          element={<ProtectedRoute
            element={<EventOpenBettingData />}
            // requiredRoles={['Managment', 'Administrative']}
            requiredRoles={['Managment', 'Administrative', 'Tech Admin', 'Super Admin', 'Admin', 'Hyper', 'Super', 'Master']}
          />}
        />

        <Route
          path="/news"
          element={<ProtectedRoute
            element={<News />}
            // requiredRoles={['Super Admin', 'Administrative', 'Admin', 'Sub Admin', 'Hyper', 'Super Master', 'Super', 'Master', 'Agent']}
            requiredRoles={['Managment', 'Administrative', 'Tech Admin', 'Super Admin', 'Admin', 'Hyper', 'Super', 'Master']}
          />}
        />
        <Route
          path="/banner"
          element={<ProtectedRoute
            element={<Banner />}
            // requiredRoles={['Super Admin', 'Administrative', 'Admin', 'Sub Admin', 'Hyper', 'Super Master', 'Super', 'Master', 'Agent']}
            requiredRoles={['Managment', 'Administrative', 'Tech Admin', 'Super Admin', 'Admin', 'Hyper', 'Super', 'Master']}
          />}
        />
        <Route
          path="/chipsummary"
          element={<ProtectedRoute
            element={<ChipSummary />}
            requiredRoles={['Managment', 'Administrative', 'Tech Admin', 'Super Admin', 'Admin', 'Hyper', 'Super', 'Master']}
          />}
        />
        <Route
          path="/clientpl"
          element={<ProtectedRoute
            element={<ClientPL />}
            requiredRoles={['Managment', 'Administrative', 'Tech Admin', 'Super Admin', 'Admin', 'Hyper', 'Super', 'Master']}
          />}
        />
        <Route
          path="/clientpl/:user_id/:user_type"
          element={<ProtectedRoute
            element={<ClientPL />}
            requiredRoles={['Managment', 'Administrative', 'Tech Admin', 'Super Admin', 'Admin', 'Hyper', 'Super', 'Master']}
          />}
        />
        <Route
          path="/marketpl"
          element={<ProtectedRoute
            element={<MarketPL />}
            requiredRoles={['Managment', 'Administrative', 'Tech Admin', 'Super Admin', 'Admin', 'Hyper', 'Super', 'Master']}
          />}
        />
        <Route
          path="/sportpl"
          element={<ProtectedRoute
            element={<SportPL />}
            requiredRoles={['Managment', 'Administrative', 'Tech Admin', 'Super Admin', 'Admin', 'Hyper', 'Super', 'Master']}
          />}
        />
        <Route
          path="/sportpl/:user_id/:user_type"
          element={<ProtectedRoute
            element={<SportPL />}
            requiredRoles={['Managment', 'Administrative', 'Tech Admin', 'Super Admin', 'Admin', 'Hyper', 'Super', 'Master']}
          />}
        />
        <Route
          path="/matchpl"
          element={<ProtectedRoute
            element={<MatchPL />}
            requiredRoles={['Managment', 'Administrative', 'Tech Admin', 'Super Admin', 'Admin', 'Hyper', 'Super', 'Master']}
          />}
        />
        <Route
          path="/fancy-sale"
          element={<ProtectedRoute
            element={<FancySale />}
            requiredRoles={['Managment', 'Administrative', 'Tech Admin', 'Super Admin', 'Admin', 'Hyper', 'Super', 'Master']}
          />}
        />
        <Route
          path="/match-sale"
          element={<ProtectedRoute
            element={<MatchSale />}
            requiredRoles={['Managment', 'Administrative', 'Tech Admin', 'Super Admin', 'Admin', 'Hyper', 'Super', 'Master']}
          />}
        />
        <Route
          path="/password-history"
          element={<ProtectedRoute
            element={<PasswordHistory />}
            // requiredRoles={['Super Admin', 'Administrative', 'Admin', 'Sub Admin', 'Hyper', 'Super Master', 'Super', 'Master', 'Agent']}
            requiredRoles={['Managment', 'Administrative', 'Tech Admin', 'Super Admin', 'Admin', 'Hyper', 'Super', 'Master']}
          />}
        />
        <Route
          path="/restore-user"
          element={<ProtectedRoute
            element={<RestoreUser />}
            requiredRoles={['Managment', 'Administrative', 'Tech Admin', 'Super Admin', 'Admin', 'Hyper', 'Super', 'Master']}
          />}
        />

        <Route
          path="/block-event-types"
          element={<ProtectedRoute
            element={<EventType />}
            // requiredRoles={['Super Admin', 'Administrative', 'Admin', 'Sub Admin', 'Hyper', 'Super Master', 'Super', 'Master', 'Agent']}
            requiredRoles={['Managment', 'Administrative', 'Tech Admin', 'Super Admin', 'Admin', 'Hyper', 'Super', 'Master']}
          />}
        />

        <Route
          path="/block-events/:event_type"
          element={<ProtectedRoute
            element={<BlockedEvents />}
            // requiredRoles={['Super Admin', 'Administrative', 'Admin', 'Sub Admin', 'Hyper', 'Super Master', 'Super', 'Master', 'Agent']}
            requiredRoles={['Managment', 'Administrative', 'Tech Admin', 'Super Admin', 'Admin', 'Hyper', 'Super', 'Master']}
          />}
        />

        <Route
          path="/block-market-types/:event_type_id/:event_id/:event_name"
          element={<ProtectedRoute
            element={<BlockedMarketTypes />}
            // requiredRoles={['Super Admin', 'Administrative', 'Admin', 'Sub Admin', 'Hyper', 'Super Master', 'Super', 'Master', 'Agent']}
            requiredRoles={['Managment', 'Administrative', 'Tech Admin', 'Super Admin', 'Admin', 'Hyper', 'Super', 'Master']}
          />}
        />
        <Route
          path='/user-general-setting/:user_id'
          element={<ProtectedRoute
            element={<UserGeneralSetting />}
            // requiredRoles={['Super Admin', 'Administrative', 'Admin', 'Sub Admin', 'Hyper', 'Super Master', 'Super', 'Master', 'Agent']}
            requiredRoles={['Managment', 'Administrative', 'Tech Admin', 'Super Admin', 'Admin', 'Hyper', 'Super', 'Master']}
          />}
        />

        <Route
          path='/event-user-general-setting'
          element={
            <ProtectedRoute
              element={<EventGeneralSetting />}
              // requiredRoles={['Super Admin', 'Administrative', 'Admin', 'Sub Admin', 'Hyper', 'Super Master', 'Super', 'Master', 'Agent']}
              requiredRoles={['Managment', 'Administrative', 'Tech Admin', 'Super Admin', 'Admin', 'Hyper', 'Super', 'Master']}
            />
          }
        />
        <Route
          path='/event-setting-market-events/:event_type_id'
          element={
            <ProtectedRoute
              element={<EventSettingMarketEvents />}
              // requiredRoles={['Super Admin', 'Administrative', 'Admin', 'Sub Admin', 'Hyper', 'Super Master', 'Super', 'Master', 'Agent']}
              requiredRoles={['Managment', 'Administrative', 'Tech Admin', 'Super Admin', 'Admin', 'Hyper', 'Super', 'Master']}
            />
          }
        />
        <Route
          path='/event-general-setting-update/:event_type_id/:event_id'
          element={
            <ProtectedRoute
              element={<EventSettingUpdate />}
              // requiredRoles={['Super Admin', 'Administrative', 'Admin', 'Sub Admin', 'Hyper', 'Super Master', 'Super', 'Master', 'Agent']}
              requiredRoles={['Managment', 'Administrative', 'Tech Admin', 'Super Admin', 'Admin', 'Hyper', 'Super', 'Master']}
            />
          }
        />

      </Routes>
      {/* </WebSocketContext.Provider> */}
    </WebSocketProvider >

  );

}

export default App;
